<template>
  <div class="users">
    <user-change-password
      :user="selectedUser"
      v-on:close-dialog="closeDialog"
      v-on:change-password="onSuccess"
      v-on:error="onError"
      :changePasswordDialog="changePasswordDialog"
    />
    <user-edit-user
      :user="selectedUser"
      v-on:close-dialog-edit-user="closeDialogEditUser"
      v-on:user-list-update="onUpdateUserList"
      v-on:error="onError"
      :showDialogEditUser="showDialogEditUser"
    />
    <user-add-price-list
      :user="selectedUser"
      v-on:close-dialog-price="closeDialogPrice"
      v-on:update-user="onSuccessPrice"
      v-on:error="onError"
      :showDialog="showDialogPrice"
    />
    <confirm-dialog
      :showDialogConfirm="showDialogConfirm"
      :message="message"
      v-on:close-dialog="closeDialogConfirm"
      v-on:accept="acceptConfirm"
    />
    <user-edit-total-queries
      :user="selectedUser"
      v-on:close-dialog-total="closeDialogTotal"
      v-on:update-user="onSuccessTotal"
      v-on:error="onError"
      :showDialogTotalQueries="showDialogTotalQueries"
    />
    <v-container>
      <v-card  flat  >
        <v-card-title primary-title>
          <v-layout row wrap>
            <v-flex xs8 >
              <h1>Usuarios</h1>
            </v-flex>
            <v-flex xs2>
              <v-switch v-model="showInactive">
                <template v-slot:label>Inactivos</template>
              </v-switch>
            </v-flex>
            <v-flex xs1>
              <v-dialog v-model="dialog" max-width="600px">
                <v-btn slot="activator" color="blue-grey darken-2 white--text" dark class="mb-2">Nuevo</v-btn>
                <v-form v-model="valid">
                <v-card>
                  <v-card-title primary-title>
                    <h1>Nuevo Usuario</h1>
                  </v-card-title>

                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12 sm6>
                          <v-text-field v-model="editedUser.username"
                          prepend-inner-icon="perm_identity"
                          label="Usuario" :rules="required" :solo="solo"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-text-field type="password" v-model="editedUser.password"
                          prepend-inner-icon="lock"
                          label="Contraseña"  :solo="solo"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-text-field
                            type="password"
                            v-model="editedUser.confirmPassword"
                            prepend-inner-icon="lock"
                            label="Confirmar Contraseña"
                            :rules="passwordConfirmationRules"  :solo="solo"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-text-field v-model="editedUser.name"
                          prepend-inner-icon="person"
                          :rules="required" label="Nombre Completo"  :solo="solo"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-text-field v-model="editedUser.email"
                          prepend-inner-icon="email"
                          label="Correo Electrónico" :rules="emailRules"  :solo="solo"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-select
                            v-model="editedUser.type"
                            prepend-inner-icon="account_box"
                            :items="userTypes"
                            item-text="label"
                            item-value="type"
                            label="Tipo"
                            single-line
                            :solo="solo"
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-text-field
                            type="number"
                            v-model="editedUser.totalQueries"
                            min="1"
                            prepend-inner-icon="tag"
                            label="Máxima consulta diaria"
                            :rules="required"  
                            :solo="solo"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-select
                            v-model="editedUser.list"
                            prepend-inner-icon="list"
                            :items="priceLists"
                            item-text="name"
                            item-value="id"
                            label="Acceso a Listas"
                            :solo="solo"
                            chips
                            deletable-chips
                            multiple
                            ref:="listSelect"
                          >
                            <template
                              slot="selection"
                              slot-scope="data"
                            >
                              <v-chip
                                close
                                @input="remove(data.item)"
                                :color="data.item.color"
                              >
                                {{ data.item['name'] }}
                              </v-chip>
                            </template>
                          </v-select>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="close">Cancelar</v-btn>
                    <v-btn color="success" @click="save" :disabled="!valid">Guardar</v-btn>
                  </v-card-actions>
                </v-card>
                </v-form>
              </v-dialog>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card v-for="u in usersToDisplay" :key="u.id" flat>
        <v-layout row wrap pa-3 >
          <v-flex  xs2 md2 centered >
            <v-avatar
              size="30"
              :color="userColor(u)"
            >
              {{u.username | firstLetter | uppercase }}
            </v-avatar>
          </v-flex>
          <v-flex  xs9 md4 ml-1 >
            <v-layout row wrap >
              <v-flex xs12 md12>
                <div class="">{{u.username}} </div>
                <div class="caption grey--text">{{u.email}}</div>
                <div v-for="(role, index) in u.roles" :key="index" class="caption grey--text">
                  {{role.name}}
                </div>
                <div class="caption grey--text">
                  Maxima consulta diaria: {{u.totalQueries}}
                </div>
                <div class="caption grey--text" v-if="u.historicDate">
                  Precios del: {{u.historicDate | formatDateTime}}
                </div>
                <div class="caption grey--text">
                  <v-switch v-model="u.active" v-on:change="togleUserStatus(u)" class="compact-form">
                    <template v-slot:label>
                      {{userStatus(u.active)}}
                    </template>
                  </v-switch>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 md4>
            <v-chip
              v-for="(item, index) in u.priceLists" :key="index"
              :color="item.color"
              small
            >
              {{item.name}}
            </v-chip>
          </v-flex>
          <v-flex xs md-4>
            <v-container>
              <v-layout row>
                <v-flex>
                  <v-icon @click="openDialogEditUser(u)">list</v-icon>
                </v-flex>
                <v-flex>
                  <v-icon @click="openDialogSelectPrice(u)">attach_money</v-icon>
                </v-flex>
                <v-flex  v-if="u.historicDate">
                  <v-icon @click="openDialogConfirmUnlik(u)">link_off</v-icon>
                </v-flex>
                <v-flex>
                  <v-icon @click="openDialogForUser(u)">lock</v-icon>
                </v-flex>
                 <v-flex>
                  <v-icon @click="editTotalQueries(u)">tag</v-icon>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>          
          <!-- <v-flex xs md>
            <v-icon @click="openDialogSelectPrice(u)">attach_money</v-icon>
          </v-flex> -->
        </v-layout>
        <v-divider></v-divider>
        </v-card>
      </v-card>
    </v-container>
  </div>
</template>

<script>

import { togleUserStatus } from '../services/user';

export default  {
  name: 'Users',
  data() {
    return {
      users: [],
      defaultUser: {
        username: '',
        password: '',
        confirmPassword: '',
        name: '',
        email: '',
        type: 'USER',
        list: [],
      },
      editedUser: {
        username: '',
        password: '',
        confirmPassword: '',
        name: '',
        email: '',
        type: 'USER',
        totalQueries: '',
        list: [],
      },
      required: [
        (v) => !!v || 'Campo requerido',
      ],
      emailRules: [
        (v) => /.+@.+/.test(v) || 'El correo debe ser valido',
      ],
      passwordConfirmationRules: [
        (v) => v === this.editedUser.password || 'Las contraseñas deben ser iguales',
      ],
      selectUserType: { type: 'USER', labe: 'Usuario' },
      selectedUser: {},
      priceLists: [],
      userTypes: [
        { type: 'CLIENT', label: 'Cliente' },
        { type: 'USER', label: 'Chofer' },
        { type: 'METAL_LOAD_BAS', label: 'Metales Básico' },
        { type: 'METAL_LOAD_ADV', label: 'Metales Avanzado' },
        { type: 'ADMINISTRATOR', label: 'Administrador' },
        { type: 'SUPERVISOR', label: 'SUPERVISOR' },
      ],
      dialog: false,
      valid: false,
      changePasswordDialog: false,
      showDialogPrice: false,
      showDialogEditUser: false,
      solo: true,
      showInactive: false,
      snackMessage: '',
      snackShow: false,
      showDialogConfirm: false,
      showDialogTotalQueries: false,
      message: ""
    };
  },
  created() {
    this.axios.get('/users')
      .then( (results) => {
        this.users = results.data;
        this.sortPricesList()
      });

    this.axios.get('/catalogs/priceCategory')
    .then( (result) => {
      this.priceLists = result.data;
    });
  },

  computed: {
    usersToDisplay() {
      return this.users.filter( (u) => {
        const showAll = true;
        return this.showInactive ?  showAll :  u.active;
      });
    },
  },

  methods: {
    sortPricesList() {
      this.users.forEach(it => {
        it.priceLists = it.priceLists.sort((a,b) => a.name.localeCompare(b.name));
      })
    },
    userStatus(active) {
      if (active) {
        return 'Activo';
      }
      return 'Inactivo';
    },
    userColor(user) {
      if (user.active) {
        return '#C1F7DC';
      } else {
        return '#C12399';
      }
    },

    getList(id) {
      const object = this.priceLists.filter( (e) => e.id === id )[0];
      return object ? object : {name: 'not found', color: '#FFF'} ;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedUser = Object.assign({}, this.defaultUser);
      }, 300);
    },
    save() {
      let pushUser = Object.assign({}, this.editedUser);
      pushUser.priceLists = []
      const levels = pushUser.list.reduce( (result, item, index, array) => {
        result['level_' + item] = 1; // a, b, c
        this.priceLists.forEach(priceList => {
          if (priceList.id === item){
            pushUser.priceLists.push(priceList)
          }
        })
        return result;
      }, {});
      pushUser = Object.assign(pushUser, levels);
      delete pushUser.list;

      this.axios.post('/users', pushUser)
        .then( (results) => {
          results.data.priceLists = pushUser.priceLists
          this.users.push(results.data);
          this.dialog = false;
          this.editedUser = Object.assign({}, this.defaultUser);
        })
        .catch( (error) => {
          this.$emit('error', error.response.data.error_message);
        });
    },
    remove(item) {
      this.editedUser.list = this.editedUser.list.filter( (e) => e !== item.label );
      // that.$refs.listSelect.isMenuActive  = false;
    },
    openDialogForUser(user) {
      this.selectedUser = user;
      this.changePasswordDialog = true;
    },
    openDialogSelectPrice(user) {
      this.selectedUser = user;
      this.showDialogPrice = true;
    },  
    openDialogEditUser(user) {
      this.selectedUser = user;
      this.showDialogEditUser = true;
    },
    editTotalQueries(user){
      console.log("sadas");
      this.selectedUser = user
      this.showDialogTotalQueries = true
    },
    openDialogConfirmUnlik(user) {
      this.selectedUser = user
      this.showDialogConfirm = true
      this.message = "¿Estas seguro que quieres eliminar la lista de precios del usuario: " + user.name + "?"
    },
    acceptConfirm(){
      this.axios.delete(`/catalogs/product/linkuser/${this.selectedUser.id}`)
        .then( (results) => {
          if (results.data.statusCode === 200) {
            const index = this.users.findIndex(it =>  it.id === this.selectedUser.id)
            if(index > -1){
              this.users[index].historicDate = undefined
            }
          }
        })
        .catch( (error) => {
          this.$emit('error', error.response.data.error_message);
        });
    },
    async togleUserStatus(item) {
      try {
        const togleStatusResult = await togleUserStatus(item.id);
        this.$emit('success', 'Usuario actualizado con exito');
      } catch (error) {
        item.active = !item.active;
        this.$emit('error', error.response.data.message);
      }
    },
    closeDialogTotal(){
      this.showDialogTotalQueries = false
    },
    closeDialogConfirm(){
      this.showDialogConfirm = false
    },
    closeDialog() {
      this.changePasswordDialog = false;
    },
    closeDialogEditUser() {
      this.showDialogEditUser = false;
    },
    closeDialogPrice() {
      this.showDialogPrice = false;
    },
    onSuccessTotal(user){
      this.showDialogTotalQueries = false
       const index = this.users.findIndex(it =>  it.id === user.id)
      if(index > -1){
        this.users[index].totalQueries = user.totalQueries
      }
    },
    onSuccessPrice(data){
      this.showDialogPrice = false
      console.log(data);
      const index = this.users.findIndex(it =>  it.id === this.selectedUser.id)
      if(index > -1){
        this.users[index].historicDate = data.priceChangeDate
      }

      this.showDialogEditUser = false
      this.$emit('success', 'Usuario actualizado correctamente');
    },
    onUpdateUserList(user){
      const index = this.users.findIndex(it =>  it.id === user.id)
      if(index > -1){
        this.users[index].priceLists = user.priceLists
      }

      this.showDialogEditUser = false
      this.$emit('success', 'Usuario actualizado correctamente');
    },
    onSuccess() {
      this.$emit('success', 'Contraseña actualizada');
    },
    onError(event) {
      this.$emit('error', event);
    },
  },
};

</script>

<style scoped>
  .compact-form {
    transform: scale(0.875);
    transform-origin: left;
  }
</style>
